// Shared thumbnail registry for project cards (used by /work grid and
// the Related Projects block on each project detail page).
import googleHeroAsset from "@/assets/projects/google/google-nyc-hero.png.asset.json";
const googleHero = googleHeroAsset.url;
import buildersWorkshopHeroAsset from "@/assets/projects/builders-workshop-placeholder.jpg.asset.json";
const buildersWorkshopHero = buildersWorkshopHeroAsset.url;
import effyJewelryHeroAsset from "@/assets/projects/effy-jewelry-hero.webp.asset.json";
const effyJewelryHero = effyJewelryHeroAsset.url;
import unoSouthMiamiHeroAsset from "@/assets/projects/uno-south-miami/lobby-overview.webp.asset.json";
const unoSouthMiamiHero = unoSouthMiamiHeroAsset.url;
import evenCoastHeroAsset from "@/assets/projects/even-coast/even-coast-bar-hero.webp.asset.json";
const evenCoastHero = evenCoastHeroAsset.url;
import bafarHeroAsset from "@/assets/projects/bafar/bafar-hero.png.asset.json";
const bafarHero = bafarHeroAsset.url;
import campbellDayAsset from "@/assets/projects/campbell-apartments/exterior-day.webp.asset.json";
const campbellDay = campbellDayAsset.url;
import creameryHeroNightAsset from "@/assets/creamery/hero-night.webp.asset.json";
const creameryHeroNight = creameryHeroNightAsset.url;
import privatePenthouseHeroAsset from "@/assets/private-penthouse-hero.webp.asset.json";
const privatePenthouseHero = privatePenthouseHeroAsset.url;
import privateResidenceHeroAsset from "@/assets/private-residence-hero.webp.asset.json";
const privateResidenceHero = privateResidenceHeroAsset.url;
import birkenstockWorkspaceWideAsset from "@/assets/birkenstock-workspace-wide.webp.asset.json";
const birkenstockWorkspaceWide = birkenstockWorkspaceWideAsset.url;
import tangoRoomHeroAsset from "@/assets/projects/tango-room/tango-room-hero.png.asset.json";
const tangoRoomHero = tangoRoomHeroAsset.url;
import floNetworksHeroAsset from "@/assets/projects/flo-networks/flo-networks-hero.png.asset.json";
const floNetworksHero = floNetworksHeroAsset.url;
import lundResidenceHeroAsset from "@/assets/projects/lund-residence/lund-residence-hero-v2.png.asset.json";
const lundResidenceHero = lundResidenceHeroAsset.url;
import rimResidenceHeroAsset from "@/assets/projects/rim-residence/rim-residence-hero.png.asset.json";
const rimResidenceHero = rimResidenceHeroAsset.url;
import camilResidenceHeroAsset from "@/assets/projects/camil-residence/camil-residence-hero.png.asset.json";
const camilResidenceHero = camilResidenceHeroAsset.url;
import morgaResidenceHeroAsset from "@/assets/projects/morga-residence/morga-residence-hero.png.asset.json";
const morgaResidenceHero = morgaResidenceHeroAsset.url;
import ponyCreekRanchHeroAsset from "@/assets/projects/pony-creek-ranch/pony-creek-ranch-hero.png.asset.json";
const ponyCreekRanchHero = ponyCreekRanchHeroAsset.url;
import puebloViejoRgbAsset from "@/assets/projects/process/pueblo-viejo/state-rgb-active.webp.asset.json";
const puebloViejoRgb = puebloViejoRgbAsset.url;
import martyRobbinsLakeNightAsset from "@/assets/projects/marty-robbins/marty-robbins-lake-night.png.asset.json";
const martyRobbinsLakeNight = martyRobbinsLakeNightAsset.url;
import commissaryHeroAsset from "@/assets/projects/commissary/hero.jpg.asset.json";
const commissaryHero = commissaryHeroAsset.url;
import shyBoyHeroAsset from "@/assets/projects/shy-boy-hero.jpg.asset.json";
import speakEasyHeroAsset from "@/assets/projects/legacy/proyectos_obj7_large_3__SPEAKESAY_16MAR___66.jpg.asset.json";
const speakEasyHero = speakEasyHeroAsset.url;
const shyBoyHero = shyBoyHeroAsset.url;





export const projectImages: Record<string, string> = {
  "Casa MS": "/__l5e/assets-v1/f84c213b-28ab-4f2f-add2-28fd5c0da444/casa-ms-1.webp",
  "Private Residence": privateResidenceHero,
  "Rappi": "/__l5e/assets-v1/e50af33b-36f6-4afa-972a-a1a79d657157/rappi-open-floor-mural.jpg",
  "Media Monks": "/__l5e/assets-v1/c3e40a3a-6543-4c81-8ef6-dbf421430b3e/proyectos_obj4_big_Bu5w5xtn.jpg",
  "Tekmovil": "/__l5e/assets-v1/5cf9d44d-5989-483d-a593-00071854c5f1/proyectos_obj2_large_2__Tekmovil_Ovier_MAR21_14.jpg",
  "Telemundo": "/__l5e/assets-v1/511e2985-e7f4-4aa0-b89b-74c16c6dda62/proyectos_obj1_big_sw9jam7x.jpg",
  "Ritz Carlton": "/__l5e/assets-v1/7491c09a-eee6-4ac7-9b26-e47dc582dfb4/proyectos_obj5_big_mAf4umlA.jpg",
  "Speak Easy": speakEasyHero,
  "Marriott": "/__l5e/assets-v1/579799fb-a85e-4510-bd5a-d67f824775c5/proyectos_obj8_big_i5ezw29q.jpg",
  "Birkenstock": birkenstockWorkspaceWide,
  "Private Penthouse": privatePenthouseHero,
  "Desert Commons": "/__l5e/assets-v1/148472a4-3a30-4d08-bfa4-beccf0a89ebe/proyectos_obj11_large_DSC_6478_HDR.jpg",
  "Rothenbucher": "/__l5e/assets-v1/897e8096-3855-4e4a-9d8b-88b55bf80d1e/proyectos_obj12_large_2__ROTHENBUCHER_16MAR___12.jpg",
  "San Antonio St.": "/__l5e/assets-v1/9f9075f6-9757-446a-a347-5b0b50d4d7ac/proyectos_obj13_large_3__DOWNTOWN_16MAR___3_.jpg",
  "St. Rogers": "/__l5e/assets-v1/5a9dd51a-8364-491e-a7c8-5fc6eef64e27/proyectos_obj14_large_RAILROAD_____1.jpg",
  "Electricity Sign": "/__l5e/assets-v1/9fc445e4-1082-4e39-a368-00be3762f035/proyectos_obj15_large_3__RAV_56_8.jpg",
  "Campbell Apartments": campbellDay,
  "Quill": "/__l5e/assets-v1/22e4b4ad-0e55-4aea-9091-eb849c4221b3/proyectos_obj17_big_5djdBoxf.jpg",
  "Desert Bloom": "/__l5e/assets-v1/a277839b-2394-4b2f-a568-fed180a4ec5f/proyectos_obj18_big_bB6Cfmyo.jpg",
  "Sessions": "/__l5e/assets-v1/ce9cde85-cbe8-4821-b317-ae0b73253d37/proyectos_obj19_large_SESSIONS__2_5.jpg",
  "Salt & Honey": "/__l5e/assets-v1/b1f7f37e-aca4-43eb-8bde-fe70aeb618f0/proyectos_obj20_big_0j8y4m70.jpg",
  "Stellar": "/__l5e/assets-v1/eb28d99f-8930-4fd6-9f40-35b0779a5fb9/proyectos_obj21_big_sm4ruijB.jpg",
  "Davenport": "/__l5e/assets-v1/d451d08a-1d1a-4240-8bfa-29ba2e03c610/proyectos_obj22_big_dngABix4.jpg",
  "Lear Corporation": "/__l5e/assets-v1/3d86e7e1-fc9f-41fa-9c57-30faeb624dd0/proyectos_obj23_big_sf4eCggC.jpg",
  "Westview Residence": "/__l5e/assets-v1/34c6218c-e4e7-483e-8c99-fd176c9a93bd/proyectos_obj24_big_w7gjwqeo.jpg",
  "Headquarters": "/__l5e/assets-v1/a4db30a3-0e4b-4a02-bb91-5f3f86ce7180/proyectos_obj25_big_jn8pon0x.jpg",
  "Weekend Gallery": "/__l5e/assets-v1/b0c5cd01-8d95-4446-b605-828102548f78/proyectos_obj27_large_3._WEEKEND_16MAR___21.jpg",
  "Google Offices": googleHero,
  "Builders Workshop": buildersWorkshopHero,
  "Effy Jewelry": effyJewelryHero,
  "Uno South Pointe": unoSouthMiamiHero,
  "Even Coast": evenCoastHero,
  "Grupo Bafar": bafarHero,
  "El Paso Star": "/__l5e/assets-v1/d5691443-bd64-46d6-a251-0805363d6830/proyectos_obj3_big_5929hxz7.jpg",
  "The Creamery": creameryHeroNight,
  "Tango Room": tangoRoomHero,
  "Flo Networks": floNetworksHero,
  "Lund Residence": lundResidenceHero,
  "Rim Residence": rimResidenceHero,
  "Camil Residence": camilResidenceHero,
  "Morga Residence": morgaResidenceHero,
  "Pony Creek Ranch": ponyCreekRanchHero,
  "Pueblo Viejo Interactive Park": puebloViejoRgb,
  "Marty Robbins Interactive Park": martyRobbinsLakeNight,
  "Commissary": commissaryHero,
  "Shy Boy": shyBoyHero,
};
